import { Box, useTheme } from "@mui/material";


import MoveDownIcon from '@mui/icons-material/MoveDown';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useFinishPickingJobMutation, useFullCompletePickingJobMutation, useOpenPickingJobMutation } from "../../../../newapi/pickingjob/pickingjobSlice";
import { tokens } from "../../../../theme";
import PopoverModal from "../../../theme/Modal/PopoverModal";
import Text from "../../../theme/text/Text";
import { ActionButton } from "./components/ActionButton";
import { ActionIcon } from "./components/ActionIcon";
import MEcheckTransferJob from "../MEcheckTransferJob";
import MConfirmation from "../MConfirmation";
import MConfirmEndPickingJob from "../MConfirmEndPickingJob";
import { toast } from "react-toastify";
import NotInterestedOutlinedIcon from '@mui/icons-material/NotInterestedOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import SidepanelLoader from "../../../theme/sidepanel2/SidepanelLoader";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { showToastMessageUpdateRequest } from "../../../../utils/toasts";

export const AMStreamInProrgess = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);

    const [openPickingJob, {isLoading: openPickingJobLoading}] = useFinishPickingJobMutation();
    const [completePickingJob, {isLoading: completePickingJobLoading}] = useFullCompletePickingJobMutation();
    const [transerJobModalOpen, setTranserJobModalOpen] = useState(false);
    const addModal = {
        open: transerJobModalOpen,
        setOpen: setTranserJobModalOpen
    }
    
    const handleClose = (reload) => {
        setTranserJobModalOpen(false);
        if(reload){
            props.onClose();
            if (props.resetScreen) props.resetScreen();
            try { if (props.refetchJobs) props.refetchJobs(); } catch(e) {}
        }
    };

    const [confirmEndStreamModalOpen, setConfirmEndStreamModalOpen] = useState(false);
    const confirmEndStreamModal = {
        open: confirmEndStreamModalOpen,
        setOpen: setConfirmEndStreamModalOpen,
    };

    const handleConfirmEndStreamClose = () => {
        confirmEndStreamModal.setOpen(false);
    };

    const handleEndStream = async (setPickedToOpen) => {
        if(openPickingJobLoading) return;

        await openPickingJob({ pickingJobId: props.item.id, setPickedToOpen })
        .unwrap()
        .then(res => {
            showToastMessageUpdateRequest(t,res);
            props.onClose();
            if (props.resetScreen) props.resetScreen();
            try { if (props.refetchJobs) props.refetchJobs(); } catch(e) {}
        })
        .catch(error => {
            console.log(error);
            props.setHighlightColor('red');
            toast.error(error.data?.message ??  `Er is iets misgegaan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }


    const [confirmCompleteStreamModalOpen, setConfirmCompleteStreamModalOpen] = useState(false);
    const confirmCompleteStreamModal = {
        open: confirmCompleteStreamModalOpen,
        setOpen: setConfirmCompleteStreamModalOpen,
    };

    const handleConfirmCompleteStreamClose = () => {
        confirmCompleteStreamModal.setOpen(false);
    };

    const handleCompleteStream = async () => {
        if(completePickingJobLoading) return;

        await completePickingJob(props.item.id)
        .unwrap()
        .then(res => {
            showToastMessageUpdateRequest(t,res);
            props.onClose();
            if (props.resetScreen) props.resetScreen();
            try { if (props.refetchJobs) props.refetchJobs(); } catch(e) {}
        })
        .catch(error => {
            console.log(error);
            props.setHighlightColor('red');
            toast.error(error.data?.message ??  `Er is iets misgegaan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    

    return (
        <PopoverModal
            {...props}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                    padding:1.5,
                    paddingBottom: isStandAlone ? 4 : 1.5,
                    display:"flex",
                    gap:1,
                    flexDirection:"column",
                    borderRadius:"24px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >
               
                <ActionButton
                    onClick={() => {
                        props.onClose();
                        props.activateStreamPanel(0);
                    }}
                >
                    <ActionIcon
                        // color={colors.green[400]}
                    >
                        <VisibilityOutlinedIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('view_job')}
                        </Text>
                    </Box>
                </ActionButton>

                <ActionButton
                    onClick={() => {
                        addModal.setOpen(true);
                    }}
                >
                    <ActionIcon>
                        <MoveDownIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('transfer_job')}
                        </Text>
                    </Box>
                </ActionButton>

                <ActionButton
                    onClick={() => {
                        confirmEndStreamModal.setOpen(true);
                    }}
                >
                    <ActionIcon
                        color={colors.red[400]}
                    >
                        <NotInterestedOutlinedIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('cancel_job')}
                        </Text>
                    </Box>
                </ActionButton>

                <ActionButton
                    onClick={() => {
                        confirmCompleteStreamModal.setOpen(true);
                    }}
                >
                    <ActionIcon
                        color={colors.green[400]}
                    >
                        <CheckCircleOutlineIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('complete_job')}
                        </Text>
                    </Box>
                </ActionButton>


            </Box>

            
            <MEcheckTransferJob
                onOpen={() => addModal.setOpen(true)} 
                onClose={() => addModal.setOpen(false)} 
                open={addModal.open} 
                handleClose={handleClose}
                barcode={props.item?.barcode}
                // incData={props.incData}
            />
            <MConfirmEndPickingJob
                open={confirmEndStreamModal.open}
                handleClose={handleConfirmEndStreamClose}
                title={t("stop_pickingjob_title")}
                subtitle={t("stop_pickingjob_subtitle")}
                confirm={(setPickedToOpen) => handleEndStream(setPickedToOpen)}
            />
            <MConfirmation
                open={confirmCompleteStreamModal.open}
                handleClose={handleConfirmCompleteStreamClose}
                title={t("complete_pickingjob_title")}
                subtitle={t("complete_pickingjob_subtitle")}
                confirm={() => handleCompleteStream(true)}
            />

        </PopoverModal>
    );
}


export const AMStreamPicked = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);

    const [openPickingJob, {isLoading: openPickingJobLoading}] = useOpenPickingJobMutation();

    const [confirmOpenStreamModalOpen, setConfirmOpenStreamModalOpen] = useState(false);
    const confirmOpenStreamModal = {
        open: confirmOpenStreamModalOpen,
        setOpen: setConfirmOpenStreamModalOpen,
    };

    const handleConfirmOpenStreamClose = () => {
        confirmOpenStreamModal.setOpen(false);
    };

    const handleOpenStream = async () => {
        if(openPickingJobLoading) return;

        await openPickingJob(props.item.id)
        .unwrap()
        .then(res => {
            showToastMessageUpdateRequest(t,res);
            props.onClose();
            props.refetchJobs();
        })
        .catch(error => {
            props.setHighlightColor('red');
            toast.error(error.data?.message ??  `Er is iets misgegaan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }
    
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    

    return (
        <PopoverModal
            {...props}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                    padding:1.5,
                    paddingBottom: isStandAlone ? 4 : 1.5,
                    display:"flex",
                    gap:1,
                    flexDirection:"column",
                    borderRadius:"24px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >
               

                <ActionButton
                    onClick={() => {
                        props.onClose();
                        props.activateStreamPanel(0);
                    }}
                >
                    <ActionIcon
                        // color={colors.green[400]}
                    >
                        <VisibilityOutlinedIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('view_job')}
                        </Text>
                    </Box>
                </ActionButton>
                <ActionButton
                    onClick={() => {
                        confirmOpenStreamModal.setOpen(true);
                    }}
                >
                    <ActionIcon
                        color={theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}
                    >
                        <LockOpenIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('open_job')}
                        </Text>
                    </Box>
                </ActionButton>


            </Box>
            
            <MConfirmation
                open={confirmOpenStreamModal.open}
                handleClose={handleConfirmOpenStreamClose}
                title={t("open_pickingjob_title")}
                subtitle={t("open_pickingjob_subtitle")}
                confirm={() => handleOpenStream(true)}
                forceNoContent={true}
            />
        </PopoverModal>
    );
}

export const AMStreamFinished = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    

    return (
        <PopoverModal
            {...props}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                    padding:1.5,
                    paddingBottom: isStandAlone ? 4 : 1.5,
                    display:"flex",
                    gap:1,
                    flexDirection:"column",
                    borderRadius:"24px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >
               

                <ActionButton
                    onClick={() => {
                        props.onClose();
                        props.activateStreamPanel(1);
                    }}
                >
                    <ActionIcon
                        // color={colors.green[400]}
                    >
                        <VisibilityOutlinedIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('view_job')}
                        </Text>
                    </Box>
                </ActionButton>

            </Box>
            
        </PopoverModal>
    );
}
